import { get } from "lodash";

const getOrgCCList = (state) => {
  return get(state.orgCCList, "data", []);
};

export default { getOrgCCList };
